/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import BottomFooter from '../BottomFooter'
import Loader from '../Loader'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ADMIN_API } from '../../common/common'
import { Logout } from '../../common/Funcation'
import { postApiAdmin } from '../../service';
import moment from 'moment'
import { getTheme } from '../../common/StyleSeter'

const whoitsforsettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  // variableWidth: true,
  arrows: false,
};

let dropdown = [
  { name: 'Activity Log', value: 'activity-log' },
]


function ActivityLogNew(props: any) {
  const userData = useSelector((e: any) => e.Header);
  const { userId } = props
  const navigate = useNavigate()
  const [isLoadingMain, setIsLoadingMain] = useState(true)
  const [pageData, setPageData] = useState<any>({})
  const DD = useSelector((e: any) => e.domainDetails);
  const [activeDD, setActiveDD] = useState(false)
  const [selectedDropdown, setSelectedDropdown] = useState('Activity Log')

  // console.log("userData", userData);


  useEffect(() => {

    if (userData) {
      getPageData()
    }

    return () => {

    }
  }, [userData])

  const handleDDselect = (value: string) => {
    setSelectedDropdown(value)
    setActiveDD(false)
  }


  const getPageData = async () => {

    setIsLoadingMain(true)

    let data = {
      api: ADMIN_API.MY_ACCOUNT.GET_ACTIVITIES,
      value: {
        id: userId ? userId : userData?._id,
        page: '1',
        limit: '10000'
      },
    }

    await postApiAdmin(data).then(function (response) {
      // console.log(response);
      setPageData(response.data.data)

    }).catch(err => {

      if (err.response.data.statusCode === 401) {
        Logout()
        navigate('/login')
      }
    }).finally(() => {
      setIsLoadingMain(false)
    })

  }
  // console.log("pageData", pageData);


  return (
    <>
      <div className='full-wrap bottomfooter leagues'>
        {isLoadingMain ?
          <div className='loader_top'>
            <Loader />
          </div>
          :
          <>
            <style>{`
                                .paddingZero {
                                padding-left: 0px !important;
                                }
                                .sports-tab-panel {
                                      position: relative;
                                  }
            
                                  .sports-tab-scroll {
                                      position: relative;
                                      width: 100%;
                                      overflow-x: auto;
                                      overflow-y: hidden;
                                      -webkit-overflow-scrolling: touch;
                                      scrollbar-width: none;
                                  }
            
                                  .sports-tab-scroll::-webkit-scrollbar {
                                      display: none;
                                  }
            
                                  .sports-tab-list {
                                      position: relative;
                                      display: inline-flex;
                                      align-items: center;
                                      flex-wrap: nowrap;
                                      list-style: none;
                                      width: max-content;
                                      min-width: 100%;
                                      margin: 0;
                                      padding: 0 0 6px 0;
                                      box-sizing: border-box;
                                  }
            
                                  .sports-tab-panel-item {
                                      position: relative;
                                      flex: 0 0 auto;
                                      cursor: pointer;
                                      margin: 0 8px;
                                      white-space: nowrap;
                                  }
            
                                  .sports-tab-panel-item h3 {
                                      margin: 0;
                                      padding: 0;
                                      font-weight: 700;
                                      font-size: 13.52px;
                                  }
            
                                  .sports-tab-panel-item.selected h3 {
                                      font-weight: 700;
                                  }
            
                                  .sports-tab-panel-item.not-selected h3 {
                                      font-weight: 700;
                                  }
            
                                  .tab-slider {
                                      position: absolute;
                                      bottom: 0px;
                                      height: 4px;
                                      background-color: black;
                                      border-radius: 10px;
            
                                      transition:
                                          left 0.3s ease,
                                          width 0.3s ease;
            
                                      pointer-events: none;
                                  }
                                .sports-tab-panel-item h3 {
                                    margin: 0;
                                    padding: 0;
                                }
                                .sports-tab-panel-item.selected h3 {
                                    font-weight: 700;
                                    font-size: 13.52px;
                                }
                                .sports-tab-panel-item.not-selected h3 {
                                    font-weight: 700;
                                    font-size: 13.52px;
                                }
                                .tab-slider {
                                    transition: left 0.3s ease, width 0.3s ease !important;
                                    margin: 0;
                                    padding: 0;
                                }
                                .custom-calendar {
                                    background: white;
                                    border: 1px solid #d4e0e5;
                                    border-radius: 8px;
                                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                                }
                                .custom-calendar .react-datepicker__day--highlighted {
                                    background-color: #ffc107 !important;
                                    color: white !important;
                                    border-radius: 50%;
                                }
                                .custom-calendar .react-datepicker__day--selected {
                                    background-color: #ffc107 !important;
                                    color: white !important;
                                    border-radius: 50%;
                                }
                                .custom-calendar .react-datepicker__header {
                                    background-color: #f8f9fa;
                                    border-bottom: 1px solid #d4e0e5;
                                    padding: 0px;
                                }
                                .custom-calendar .react-datepicker__current-month {
                                    color: #fff;
                                    font-weight: 600;
                                    height: 32px;
                                    background: ${getTheme(DD?.colorSchema)?.backgroundColor};
                                    padding-top: 3px !important;
                                }
                                .custom-calendar .react-datepicker__navigation-icon::before {
                                    border-color: white;
                                }
                                .custom-calendar .react-datepicker__navigation-icon:hover::before {
                                    border-color: white;
                                }
                                .custom-calendar .react-datepicker__navigation {
                                    background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                                    border-radius: 4px;
                                    width: 32px;
                                    height: 32px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    top: 0px;
                                }
                                .custom-calendar .react-datepicker__navigation:hover {
                                    background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                                    opacity: 0.8;
                                }
                                .custom-calendar .react-datepicker__day-name {
                                    color: #666;
                                    font-weight: 500;
                                }
                                .custom-calendar .react-datepicker__day {
                                    color: #333;
                                }
                                .custom-calendar .react-datepicker__day:hover {
                                    background-color: #e9ecef;
                                }
                                .calendar-dropdown {
                                    animation: slideDown 0.3s ease;
                                }
                                .pl-filter .select-container .dropdown-toggle::after{
                                    margin-left: auto !important;
                                }
                                @keyframes slideDown {
                                    from {
                                        opacity: 0;
                                        max-height: 0;
                                        overflow: hidden;
                                    }
                                    to {
                                        opacity: 1;
                                        max-height: 500px;
                                        overflow: visible;
                                    }
                                }
                                .active-log-table table.table-bordered > :not(caption) > * > *{
                                    border-width: 1px 0 0 0;
                                }
                            `}</style>
            <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
              {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                          <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
                        </svg>
                      </button> */}
              Activity Log
              <div className='cross-icon' onClick={() => navigate('/')} />
            </div>
            <div className="pl-filter">
              <div className="select-container bet-history-dropdown">
                <div className="dropdown">
                  <button type="button" onClick={() => setActiveDD(!activeDD)} id="dropdown-basic-button" aria-expanded="false"
                    className={`${activeDD ? 'show' : ''} dropdown-toggle btn btn-primary`} style={{ justifyContent: "start", fontWeight: 700, width: "100%" }}>
                    {selectedDropdown}
                  </button>
                  {/* <div x-placement="bottom-start" aria-labelledby="dropdown-basic-button" className={`${activeDD ? 'show' : ''} dropdown-menu`} data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom-start" style={{ paddingLeft: "87px", paddingRight: "1rem" }}
                  >

                    {dropdown.filter((_) => _.name !== selectedDropdown).map((item, i) => {
                      return (
                        <>
                          <a className="dropdown-item" style={{ padding: 0, height: "31px", fontWeight: 700 }} onClick={() => handleDDselect(item.name)}> {item.name}</a> </>
                      )
                    })}
                  </div> */}
                </div>
              </div>

            </div>

            <div className="p-3" style={{ backgroundColor: "#eef6fb" }}>
              <div className="active-log-table">

                {pageData?.userActivitie && pageData?.userActivitie?.results.length > 0 ? pageData?.userActivitie?.results.map((item: any, i: any) => {
                  return (
                    <>
                      <table className="rounded overflow-hidden table table-bordered" style={{ marginBottom: "0.5rem" }} key={i} >
                        <thead>
                          <tr>
                            <th colSpan={4} style={{ fontSize: "12.49px", fontWeight: 400 }}>{moment(item.createdAt).format('DD/MM/YYYY hh:mm:ss')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={4} style={{ fontSize: "11.45px" }}>Login Status <strong className="d-block" style={{ color: 'green', fontSize: "14.57px", fontWeight: 700 }}>Login Success</strong></td>
                          </tr>
                          <tr>
                            <td width="40%" style={{ fontSize: "12.49px", fontWeight: 400 }}>IP Address</td>
                            <td width="60%" style={{ fontSize: "12.49px", fontWeight: 700, color: "#6F8898" }}>{item.ip_address}</td>
                          </tr>
                          <tr>
                            <td width="40%" style={{ fontSize: "12.49px", fontWeight: 400 }}>ISP</td>
                            <td width="60%" style={{ fontSize: "12.49px", fontWeight: 400 }}>{item?.ISP}</td>
                            {/* <td width="60%" style={{ fontSize: "12.49px", fontWeight: 700, color: "#6F8898" }}>******</td> */}

                          </tr>
                          <tr>
                            <td width="40%" style={{ fontSize: "12.49px", fontWeight: 400 }}>City/State/Country</td>
                            <td width="60%" style={{ fontSize: "12.49px", fontWeight: 400 }}>{item?.city}-{item?.state}-{item?.country}</td>
                            {/* <td width="60%" style={{ fontSize: "12.49px", fontWeight: 700, color: "#6F8898" }}>******</td> */}
                          </tr>
                          <tr>
                            <td width="40%" style={{ fontSize: "12.49px", fontWeight: 400 }}>Action</td>
                            <td width="60%" style={{ fontSize: "12.49px", fontWeight: 600 }}>
                              <button style={{ padding: "4px 12px", background: "#e1e1e1", color: "#000", borderRadius: "4px", fontSize: "12.49px", fontWeight: 600, border: "none" }}>View</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )
                }) : <div className='p-3'>
                  <div className="no-event-outer">
                    <div className="no-event">
                      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                      </svg>
                      No Event
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </>
        }
      </div>
    </>
  )
}

export default ActivityLogNew